import React from 'react';
import {renderRoutes} from "react-router-config";
import {Route} from "react-router";

import {routes} from "./Router";
import BaseComponent, {registerDoError} from "./redare/components/BaseComponent";
import BrowserRouter from "./redare/components/router/BrowserRouter";
import {appApiInit} from "./AppApi";

appApiInit({key: `${(window._workbench || {})._apiKey}`});

class DoError extends BaseComponent {

    _doError(error) {
        switch (error.code) {
            case 1000: //需要重新登录
                let {loginUrl} = error.data || {};
                let backUrl = encodeURIComponent(window.location.href);
                if (loginUrl) {
                    if (loginUrl.indexOf('?') >= 0) {
                        loginUrl = `${loginUrl}&backUrl=${backUrl}`;
                    } else {
                        loginUrl = `${loginUrl}?backUrl=${backUrl}`;
                    }
                } else {
                    loginUrl = `${window._ctxApi}/login?backUrl=${backUrl}`;
                }
                this.routeReplace(this.props.history, loginUrl);
                break;
            default:
                break;
        }
    }

    componentDidMount() {
        registerDoError(this._doError.bind(this));
    }

    render() {
        return null;
    }
}

export default class App extends BaseComponent {

    render() {
        return (
            <BrowserRouter>
                <Route path="/" render={(props) => <DoError {...props}/>}/>
                {renderRoutes(routes)}
            </BrowserRouter>
        )
    }
}